export default __webpack_public_path__ + "static/erdinger_radler_1-96b9e71c3499e1e3b64a1f077ff39c58.png";